import TextArea from 'antd/lib/input/TextArea';
import React from 'react';

interface Props {
  rows?: number;
}

const MechanicsRecordRequestedServices = ({ rows = 3 }: Props) => {
  return (
    <table width="100%" cellPadding={4} cellSpacing={0}>
      <thead>
        <tr>
          <th colSpan={2} align="left">
            Serviços solicitados:
          </th>
        </tr>
      </thead>

      <tbody>
        {Array.from({ length: rows }).map((_, index) => (
          <tr key={index}>
            <td>
              <TextArea rows={1} />
            </td>
            <td>
              <TextArea rows={1} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MechanicsRecordRequestedServices;
